/**
 * Mobile-Optimized Modal Component
 * Uses dynamic height calculation instead of viewport units
 */
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import useMobileViewport from '../../hooks/useMobileViewport';
import './MobileModal.css';

function MobileModal({ 
  isOpen, 
  onClose, 
  children,
  title,
  className = ''
}) {
  const { viewportHeight, keyboardVisible, isMobile } = useMobileViewport();
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen && isMobile && modalRef.current) {
      // Set dynamic height
      const modalElement = modalRef.current;
      modalElement.style.height = `${viewportHeight}px`;
      
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${window.scrollY}px`;
    }

    return () => {
      if (isOpen) {
        // Restore body scroll
        const scrollY = document.body.style.top;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    };
  }, [isOpen, viewportHeight, isMobile]);

  if (!isOpen) return null;

  const modalContent = (
    <div className="mobile-modal-backdrop" onClick={onClose}>
      <div 
        ref={modalRef}
        className={`mobile-modal-container ${className} ${keyboardVisible ? 'keyboard-visible' : ''}`}
        onClick={e => e.stopPropagation()}
        style={{ height: isMobile ? `${viewportHeight}px` : '100vh' }}
      >
        <div className="mobile-modal-header">
          <h3>{title || '편집'}</h3>
          <button className="mobile-modal-close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mobile-modal-content">
          {children}
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
}

export default MobileModal;